// export const BASEURL = 'https://isms.vitelwireless.com:4001/app4/v1';
// export const BASEURL = 'http://10.0.5.51:3022/api/v1';
// export const BASEURL = 'http://10.0.5.52:3013/api/v1';
// export const BASEURL =  'http://197.210.166.58:3025/api/v1';
export const BASEURL = 'https://iadmin.vitelwireless.com:5000/api/v1';





